import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { installGlobalClickTracker, trackPageview } from "@/lib/tracking";
import { installContentProtection } from "@/lib/contentProtection";
import AgeGate from "@/components/AgeGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import ProfileDetail from "@/pages/ProfileDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import VipLanding from "@/pages/VipLanding";
import CheckoutResult from "@/pages/CheckoutResult";
import Nearby from "@/pages/Nearby";
import Community from "@/pages/Community";
import AdminAnalytics from "@/pages/AdminAnalytics";
import Settings from "@/pages/Settings";
import Discreto from "@/pages/Discreto";
import Hotels from "@/pages/Hotels";
import HotelDetail from "@/pages/HotelDetail";
import AuthCallback from "@/pages/AuthCallback";
import FacebookAuthCallback from "@/pages/FacebookAuthCallback";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import PinLockScreen from "@/components/PinLockScreen";
import GlobalSoundFX from "@/components/GlobalSoundFX";

function PageviewTracker() {
  const loc = useLocation();
  useEffect(() => { trackPageview(loc.pathname); }, [loc.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    installGlobalClickTracker();
    installContentProtection();
    // Restore stealth icons/title if user had enabled Modo Discreto
    if (localStorage.getItem("pk2_stealth_mode") === "solitario") {
      const mf = document.querySelector('link[rel="manifest"]');
      if (mf) mf.setAttribute("href", "/manifest-solitario.json");
      document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]')
        .forEach((el) => el.parentNode.removeChild(el));
      const icons = [
        { rel: "icon", type: "image/png", sizes: "16x16", href: "/solitario-16.png" },
        { rel: "icon", type: "image/png", sizes: "32x32", href: "/solitario-32.png" },
        { rel: "icon", type: "image/png", sizes: "192x192", href: "/solitario-192.png" },
        { rel: "apple-touch-icon", sizes: "180x180", href: "/solitario-apple-touch.png" },
        { rel: "shortcut icon", href: "/solitario.ico" },
      ];
      icons.forEach(({ rel, type, sizes, href }) => {
        const link = document.createElement("link");
        link.rel = rel;
        if (type) link.type = type;
        if (sizes) link.setAttribute("sizes", sizes);
        link.href = href;
        document.head.appendChild(link);
      });
      document.title = "Solitario Clásico";
    }
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageviewTracker />
        <GlobalSoundFX />
        <AgeGate />
        <PinLockScreen />
        <div className="grain" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          <Navbar />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/musa/:id" element={<ProfileDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/acceder" element={<Login />} />
              <Route path="/registro" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/vip" element={<VipLanding />} />
              <Route path="/cerca" element={<Nearby />} />
              <Route path="/comunidad" element={<Community />} />
              <Route path="/ajustes" element={<Settings />} />
              <Route path="/discreto" element={<Discreto />} />
              <Route path="/hoteles" element={<Hotels />} />
              <Route path="/hoteles/:id" element={<HotelDetail />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/auth/callback/facebook" element={<FacebookAuthCallback />} />
              <Route path="/terminos" element={<Terms />} />
              <Route path="/privacidad" element={<Privacy />} />
              <Route path="/checkout/success" element={<CheckoutResult success />} />
              <Route path="/checkout/cancel" element={<CheckoutResult success={false} />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
